<template>
  <div>

    <div v-if="puzzleOrder.attributes.feedback == null">
      Feedback on your experience:
      <v-dialog
          v-model="dialog"
          width="100%"
          max-width="400" >
        <template v-slot:activator="{ on, attrs }" >
          <v-btn small color="orange"  v-bind="attrs"
                 v-on="on">Give Feedback</v-btn>
        </template>

        <v-card>
          <v-col cols="6" style="margin: 0 auto"  class="pt-5 pb-5" v-if="modified">
            <v-progress-linear
                color="blue accent-4"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
          </v-col>
          <v-container class="align-center" v-if="!modified">

            <h3 class="text-center">Puzzling Feedback</h3>
            <p>Did you like your puzzling experience?</p>


            <v-radio-group v-model="localPuzzleOrder.liked">
              <v-radio
                  :value="true"
              >
                <template slot="label">
                  <v-icon>mdi-thumb-up-outline</v-icon>
                  Liked
                </template>
              </v-radio>
              <v-radio
                  :value="false"
              >
                <template slot="label">
                  <v-icon>mdi-thumb-down-outline</v-icon>
                  Disliked
                </template>
              </v-radio>
            </v-radio-group>
            <p>Were there pieces that were unable to be used?</p>


            <v-radio-group v-model="localPuzzleOrder.hasUnusablePieces">
              <v-radio
                  :value="true"
              >
                <template slot="label">
                  Yes
                </template>
              </v-radio>
              <v-radio
                  :value="false"
              >
                <template slot="label">
                  No
                </template>
              </v-radio>
            </v-radio-group>
            <p>Any missing pieces?</p>
            <v-radio-group v-model="localPuzzleOrder.hasMissingPiece">
              <v-radio
                  :value="true"
              >
                <template slot="label">
                  Yes
                </template>
              </v-radio>
              <v-radio
                  :value="false"
              >
                <template slot="label">
                  No
                </template>
              </v-radio>
            </v-radio-group>

            <v-text-field v-if="localPuzzleOrder.hasMissingPiece" v-model="localPuzzleOrder.numberOfMissingPieces" label="How many missing pieces?"
            >

            </v-text-field>

            <p>Did the puzzle meet your preferences?</p>


            <v-radio-group v-model="localPuzzleOrder.didMeetPreferences">
              <v-radio
                  :value="true"
              >
                <template slot="label">
                  Yes, it met my level, theme and wishlist
                </template>
              </v-radio>
              <v-radio
                  :value="false"
              >
                <template slot="label">
                  No, not this time
                </template>
              </v-radio>
            </v-radio-group>

            <p>
              Provide any additional feedback
            </p>
            <v-textarea filled v-model="localPuzzleOrder.feedback" rows="3">

            </v-textarea>
            <div class="d-flex">
              <v-btn
                  color="success"
                  @click="submit"
                  :disabled="localPuzzleOrder.liked == null"
              >
                Save
              </v-btn>
              <v-spacer class="d-none d-flex"></v-spacer>
              <v-btn
                  color="warning"
                  @click="dialog = false"
              >
                Cancel
              </v-btn>
            </div>
            <div class="text-center "><small>You cannot edit this once submitted</small></div>
          </v-container>
        </v-card>
      </v-dialog>
    </div>

    <div v-if="puzzleOrder.attributes.feedback != null">
      <p>Feedback at: {{this.getDateString(puzzleOrder.attributes.feedbackAt)}}</p>
      <p>Liked: {{puzzleOrder.attributes.liked ? 'Yes!' : 'disliked'}}</p>
      <p>Feedback notes: {{puzzleOrder.attributes.feedback}}</p>
    </div>

  </div>
</template>

<script>
  import {mapState} from "vuex";
  import {mapGetters} from "vuex";

  export default {
    name: 'feedback-display',
    components: {
    },
    computed: {
      ...mapGetters({
        puzzleOrders: 'getPuzzleOrders',
        modified: 'getModifiedPuzzleOrder'
      }),
      ...mapState({
      }),
    },
    created: function(){
    },
    mounted: function(){
      this.copyLocal()
    },
    methods: {
      getDateString: function(date){
        let d = new Date(date);
        return d.toLocaleDateString();
      },
      submit: function(){
        this.$store.dispatch("updatePuzzleFeedback", this.localPuzzleOrder)
      },
      copyLocal: function(){
        if (this.puzzleOrderId != 0 && this.puzzleOrderId != null) {
          for (let index in Object.keys(this.puzzleOrders)) {
            let key = Object.keys(this.puzzleOrders)[index];
            if (this.puzzleOrders[key].id == this.puzzleOrderId){
              this.puzzleOrder = this.puzzleOrders[key];
              Object.keys(this.puzzleOrder.attributes).forEach(key => {
                this.localPuzzleOrder[key] = this.puzzleOrder[key]
              });
              this.localPuzzleOrder['id'] = this.puzzleOrder.id
            }
          }
        }
      },
    },
    watch: {
      'puzzleOrderId': function(){
        this.copyLocal();
      },
      modified: {
        handler(n,o) {
          if (!n && o){
            this.dialog = false
            this.copyLocal()
          }
        },
        deep: true
      }
    },
    data: function(){
      return {
        localPuzzleOrder: {
          liked: null,
          hasMissingPiece: null,
          numberOfMissingPieces: null,
          hasUnusablePieces: null,
          didMeetPreferences: null,
          feedback: null
        },
        dialog: false,
        puzzleOrder: {
          attributes: {
            liked: null,
            hasMissingPiece: null,
            numberOfMissingPieces: null,
            hasUnusablePieces: null,
            didMeetPreferences: null,
            feedback: null,
            feedbackAt: null,
          }
        },
      }
    },
    props: {
      puzzleOrderId: null
    }
  }
</script>
<style scoped>


</style>
